/**
 * CMS may strip __item / __itemBody / __callout wrappers.
 * Rebuilds DOM for .website-check-board (see _websiteCheckBoard.scss).
 */
export function structureWebsiteCheckBoard(root) {
  if (!root) return;

  const containers = [];
  if (root.classList.contains('website-check-board')) {
    containers.push(root);
  }
  root.querySelectorAll('.website-check-board').forEach((el) => {
    if (!containers.includes(el)) {
      containers.push(el);
    }
  });

  containers.forEach((container) => {
    if (container.querySelector('.website-check-board__item')) {
      return;
    }

    const list = container.querySelector('.website-check-board__list') || container;
    const icons = [...list.querySelectorAll('.website-check-board__icon')];

    icons.reverse().forEach((iconEl) => {
      let titleEl = iconEl.querySelector(':scope > .website-check-board__itemTitle');
      if (!titleEl) {
        titleEl = iconEl.nextElementSibling;
      }
      if (!titleEl || !titleEl.classList.contains('website-check-board__itemTitle')) {
        return;
      }

      const item = document.createElement('div');
      item.className = 'website-check-board__item';
      const body = document.createElement('div');
      body.className = 'website-check-board__itemBody';

      const parent = iconEl.parentNode;
      parent.insertBefore(item, iconEl);
      item.appendChild(iconEl);
      item.appendChild(body);
      body.appendChild(titleEl);
    });

    if (!container.querySelector('.website-check-board__callout')) {
      const calloutText = container.querySelector('.website-check-board__calloutText');
      if (calloutText) {
        const callout = document.createElement('div');
        callout.className = 'website-check-board__callout';
        calloutText.parentNode.insertBefore(callout, calloutText);
        callout.appendChild(calloutText);
      }
    }
  });
}
